/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:17
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-10 12:09:10
 * @FilePath: \eu-eswop-official-site\src\router\index.js
 * @Description:
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import { vm } from '@/locales'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/order'
  },
  // {
  //   path: '/home',
  //   name: 'Home',
  //   component: () => import('../views/home/index.vue')
  // },
  // {
  //   path: '/home/whoAreWe',
  //   name: 'WhoAreWe',
  //   component: () => import('../views/home/whoAreWe.vue')
  // },
  // {
  //   path: '/home/business',
  //   name: 'Business',
  //   component: () => import('../views/home/business.vue')
  // },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('../views/privacyPolicy/index.vue')
  },
  {
    path: '/cookiePrivadidad',
    name: 'cookiePrivadidad',
    component: () => import('../views/cookiePrivadidad/cookiePrivadidad.vue')
  },
  {
    path: '/cookiePriva',
    name: 'cookiePriva',
    component: () => import('../views/cookiePriva/index.vue')
  },
  {
    path: '/termsAndConditions',
    name: 'TermsAndConditions',
    component: () => import('../views/termsAndConditions/index.vue')
  },
  {
    path: '/FAQs',
    name: 'FAQs',
    component: () => import('../views/FAQs/index.vue')
  },
  {
    path: '/product',
    name: 'Product',
    meta: { title: vm.$t('router.selectModel') }, // 选择机型
    component: () => import('../views/product/productContainer.vue')
  },
  // {
  //   path: '/search',
  //   name: 'Search',
  //   component: () => import('../views/search/searchContainer.vue')
  // },
  // {
  //   path: '/blogList',
  //   name: 'blogList',
  //   component: () => import('../views/blog/index.vue')
  // },
  // {
  //   path: '/blogDetail',
  //   name: 'BlogDetail',
  //   component: () => import('../views/blog/blogDetail.vue')
  // },
  // {
  //   path: '/property',
  //   name: 'Property',
  //   meta: { title: vm.$t("router.selectProperty") }, // 选择估价信息
  //   component: () => import('../views/property/propertyContainer.vue')
  // },
  // {
  //   path: '/evaluate',
  //   name: 'Evaluate',
  //   meta: { title: vm.$t("router.price") }, // 预估价
  //   component: () => import('../views/evaluate/evaluateContainer.vue')
  // },
  // {
  //   path: '/settleAccount',
  //   name: 'SettleAccount',
  //   meta: { title: vm.$t("router.priceOrder") }, // 预估价2 信息填写
  //   component: () => import('../views/settleAccount/settleAccountContainer.vue')
  // },
  {
    path: '/personalInfo',
    name: 'PersonalInfo',
    meta: { title: vm.$t('router.priceOrder') }, // 个人信息收集
    component: () => import('../views/personalInfo/personalInfo.vue')
  },
  {
    path: '/successOrder',
    name: 'SuccessOrder',
    meta: { title: vm.$t('router.orderSuccess') },
    component: () => import('../views/successOrder/successOrder.vue')
  },
  // {
  //   path: '/protocol',
  //   name: 'Protocol',
  //   meta: { title: 'Details' },
  //   component: () => import('../views/protocol/protocolContainer.vue')
  // },
  // {
  //   path: '/inspectionPhotograph',
  //   name: 'inspectionPhotograph',
  //   component: () => import('../views/upload/inspectionPhotograph.vue'),
  //   meta: { qualify: true }
  // },
  // {
  //   path: '/inspectionPhotographSuccess',
  //   name: 'inspectionPhotographSuccess',
  //   component: () => import('../views/upload/inspectionPhotographSuccess.vue'),
  //   meta: { qualify: true }
  // },
  // {
  //   path: '/inspectionPhotographfail',
  //   name: 'inspectionPhotographfail',
  //   component: () => import('../views/upload/inspectionPhotographfail.vue'),
  //   meta: { qualify: true }
  // },
  {
    path: '/shippingLable',
    name: 'shippingLable',
    component: () => import('../views/shippingLable/shippingLable.vue'),
    meta: { qualify: true }
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/order/order.vue'),
    meta: { qualify: true }
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})
// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)

}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => err)

}

export default router
